import { useQuery } from '@tanstack/vue-query'
import { getDepositRequestStatusCounts } from '../depositRequestsEndpoints'
import { depositRequestKeys } from '../depositRequestsQueryKeys'

export function useDepositRequestStatusCountsQuery() {
  return useQuery({
    queryKey: depositRequestKeys.statusCounts(),
    queryFn: () => getDepositRequestStatusCounts(),
    staleTime: 1000 * 30,
  })
}
